import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class AtualizacaoLiberacaoService extends BaseService {
  constructor() {
    super(`${ConfigApi.atualizacaoLiberacaoURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.idVersao = undefined;
    this.limit = 50;
    this.page = 0;
  }
}
export default new AtualizacaoLiberacaoService();
